export const REDUCER_NAME = 'guideTour';
export const STEP_STAUTS = 'STEP_STAUTS';
export const RESET = 'RESET';
// import { stepGuideEmployee } from 'src/features/GuideTour/step';

export const setStepIndex = stepIndex => ({
  type: STEP_STAUTS,
  stepIndex
});

export const setReset = (tourCompleted, run, stepIndex) => ({
  type: RESET,
  tourCompleted,
  run,
  stepIndex
});

const initialState = {
  run: true,
  stepIndex: 0,
  tourCompleted: false,
  // step: stepGuideEmployee.map(step => ({
  //   target: step.target,
  //   content: step.content,
  //   locale: {
  //     skip: 'スキップ',
  //     back: '前へ',
  //     next: '次へ',
  //     last: '終了'
  //   }
  // }))
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STEP_STAUTS:
      return { ...state, stepIndex: action.stepIndex };
    case RESET:
      return { ...state, tourCompleted: action.tourCompleted, stepIndex: action.stepIndex, run: action.run };
    default:
      return state;
  }
};
